(function (root) {
    var ANALYSIS_RANGES = ["ytd", "trailing_12_months", "all_time"];

    function normalizeFrappeRequestUrl(context) {
        var request = context && context.request;
        var location = context && context.location;

        if (!request || !location) {
            return;
        }

        if (
            location.hostname === "g1.shunlongauto.com" &&
            location.pathname !== "/" &&
            request.url === "/"
        ) {
            request.url = location.pathname + (location.search || "");
        }
    }

    function isAnalysisReportPage(documentRef) {
        return Boolean(documentRef && documentRef.getElementById("analysis-report-dashboard"));
    }

    function normalizeAnalysisRange(rangeKey) {
        return ANALYSIS_RANGES.indexOf(rangeKey) !== -1 ? rangeKey : "ytd";
    }

    function formatCny(value) {
        var amount = Number(value || 0);
        return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(amount).replace("-", "-CNY ").replace(/^/, amount < 0 ? "" : "CNY ");
    }

    function formatCount(value) {
        return new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(Number(value || 0));
    }

    function destroyAnalysisCharts(rootRef) {
        (rootRef.__analysisReportCharts || []).forEach(function (chart) {
            if (chart && typeof chart.destroy === "function") {
                chart.destroy();
            }
        });
        rootRef.__analysisReportCharts = [];
    }

    function getAnalysisErrorState(response) {
        return response && (response.httpStatusCode === 403 || response.status_code === 403) ? "forbidden" : "error";
    }

    function getAnalysisRequestOptions(rangeKey) {
        return {
            method: "autohaina.management_dashboard.get_analysis_report_data",
            type: "GET",
            args: { range_key: normalizeAnalysisRange(rangeKey) },
        };
    }

    function escapeHtml(value) {
        return String(value === undefined || value === null ? "" : value)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
    }

    function renderTable(rows, columns, emptyText) {
        if (!rows || !rows.length) {
            return '<div class="analysis-report-empty">' + escapeHtml(emptyText || "当前范围暂无数据") + "</div>";
        }
        var header = columns.map(function (column) {
            return "<th>" + escapeHtml(column.label) + "</th>";
        }).join("");
        var body = rows.map(function (row) {
            return "<tr>" + columns.map(function (column) {
                var value = row[column.key];
                return "<td>" + escapeHtml(column.format ? column.format(value) : value || "-") + "</td>";
            }).join("") + "</tr>";
        }).join("");
        return '<div class="analysis-report-table-wrap"><table><thead><tr>' + header + "</tr></thead><tbody>" + body + "</tbody></table></div>";
    }

    function renderAnalysisDashboard(windowRef, data, selectedRange) {
        var kpis = data.kpis || {};
        var profile = data.customer_profile || {};
        var vehicles = data.vehicles || {};
        var reportRoot = windowRef.document.getElementById("analysis-report-dashboard");
        if (!reportRoot) {
            return;
        }
        var ranges = [
            { key: "ytd", label: "年至今" },
            { key: "trailing_12_months", label: "近 12 个月" },
            { key: "all_time", label: "全部历史" },
        ];
        destroyAnalysisCharts(windowRef);
        reportRoot.innerHTML = [
            '<section class="analysis-report-header">',
            '<div><p class="analysis-report-eyebrow">MANAGEMENT REVIEW</p><h1>分析报告</h1><p class="analysis-report-period">' + escapeHtml(data.range && data.range.label) + "</p></div>",
            '<div class="analysis-report-range-control" role="group" aria-label="分析范围">',
            ranges.map(function (range) {
                return '<button type="button" data-analysis-range="' + range.key + '" class="' + (range.key === selectedRange ? "is-active" : "") + '">' + range.label + "</button>";
            }).join(""),
            "</div></section>",
            '<section class="analysis-report-kpis">',
            analysisKpiCard("询价单", formatCount(kpis.xunjia_count), "本期有效询价"),
            analysisKpiCard("报价单", formatCount(kpis.baojia_count), "本期有效报价"),
            analysisKpiCard("销售单", formatCount(kpis.sales_count), "按销售日期统计"),
            analysisKpiCard("合同销售额", formatCny(kpis.contract_sales_cny), "按销售利润口径折算"),
            analysisKpiCard("实际收款", formatCny(kpis.actual_receipts_cny), "已计入有效收款"),
            analysisKpiCard("待收金额", formatCny(kpis.outstanding_receivables_cny), "合同额减实际收款"),
            "</section>",
            '<section class="analysis-report-grid">',
            analysisPanel("询价、报价与销售趋势", '<div class="analysis-report-chart" id="analysis-report-trend-chart"></div>'),
            analysisPanel("漏斗与关联覆盖", '<div class="analysis-report-chart" id="analysis-report-funnel-chart"></div>' + renderFunnelCoverage(data.funnel)),
            analysisPanel("客户画像", renderCustomerProfile(profile)),
            analysisPanel("业务员销售表现", renderTable(data.salespeople, [
                { key: "salesperson", label: "业务员" }, { key: "xunjia_count", label: "询价", format: formatCount },
                { key: "baojia_count", label: "报价", format: formatCount }, { key: "xiaoshou_count", label: "销售", format: formatCount },
                { key: "customer_count", label: "成交客户", format: formatCount },
                { key: "contract_sales_cny", label: "合同额", format: formatCny }, { key: "actual_receipts_cny", label: "收款", format: formatCny },
            ])),
            analysisPanel("销售车型", renderVehicleProfile(vehicles)),
            analysisPanel("管理预警", renderAlerts(data.alerts)),
            "</section>",
        ].join("");
        renderAnalysisCharts(windowRef, data);
    }

    function analysisKpiCard(label, value, note) {
        return '<article class="analysis-report-kpi"><p>' + label + "</p><strong>" + value + "</strong><span>" + note + "</span></article>";
    }

    function analysisPanel(title, content) {
        return '<section class="analysis-report-panel"><h2>' + title + "</h2>" + content + "</section>";
    }

    function renderCustomerProfile(profile) {
        return renderCustomerPreferenceTables(profile || {});
    }

    function renderCustomerPreferenceTables(profile) {
        return [
            '<h3>整体车型偏好 Top 10</h3>', renderTable(profile.model_preferences, [
                { key: "model", label: "车型" }, { key: "inquiry_count", label: "询价", format: formatCount },
                { key: "quote_count", label: "报价", format: formatCount }, { key: "sales_count", label: "销售单", format: formatCount },
                { key: "sales_quantity", label: "成交数量", format: formatCount },
                { key: "contract_sales_cny", label: "合同额", format: formatCny },
                { key: "actual_receipts_cny", label: "实际收款", format: formatCny },
            ]),
            '<h3>国家偏好车型 Top 10</h3>', renderTable(profile.country_model_preferences, [
                { key: "country", label: "国家" }, { key: "model", label: "车型" },
                { key: "inquiry_count", label: "询价", format: formatCount }, { key: "quote_count", label: "报价", format: formatCount },
                { key: "sales_count", label: "销售单", format: formatCount }, { key: "sales_quantity", label: "成交数量", format: formatCount },
                { key: "contract_sales_cny", label: "合同额", format: formatCny },
                { key: "actual_receipts_cny", label: "实际收款", format: formatCny },
            ]),
            '<h3>重点客户车型偏好 Top 10</h3>', renderTable(profile.customer_vehicle_preferences, [
                { key: "customer", label: "客户" }, { key: "inquiry_model", label: "最常询价车型" },
                { key: "quote_model", label: "最常报价车型" }, { key: "sales_model", label: "成交车型" },
                { key: "sales_count", label: "销售单", format: formatCount }, { key: "sales_quantity", label: "成交数量", format: formatCount },
                { key: "contract_sales_cny", label: "合同额", format: formatCny },
                { key: "actual_receipts_cny", label: "实际收款", format: formatCny },
            ]),
            '<h3>客户价值 Top 10</h3>', renderTable(profile.top_customers, [
                { key: "customer", label: "客户" }, { key: "sales_count", label: "销售单", format: formatCount },
                { key: "contract_sales_cny", label: "合同额", format: formatCny }, { key: "actual_receipts_cny", label: "收款", format: formatCny },
            ]),
        ].join("");
    }

    function renderVehicleProfile(vehicles) {
        return [
            '<h3>品牌 Top 10</h3>', renderTable(vehicles.brands, [
                { key: "label", label: "品牌" }, { key: "quantity", label: "数量", format: formatCount },
                { key: "contract_sales_cny", label: "合同额", format: formatCny },
            ]),
            '<h3>车型 Top 10</h3>', renderTable(vehicles.models, [
                { key: "label", label: "车型" }, { key: "quantity", label: "数量", format: formatCount },
                { key: "contract_sales_cny", label: "合同额", format: formatCny },
            ]),
            '<h3>车辆类型</h3>', renderTable(vehicles.vehicle_types, [
                { key: "label", label: "类型" }, { key: "quantity", label: "数量", format: formatCount },
                { key: "contract_sales_cny", label: "合同额", format: formatCny },
            ]),
        ].join("");
    }

    function renderFunnelCoverage(funnel) {
        return renderTable([
            { stage: "报价关联询价", count: funnel.baojia_linked_to_xunjia },
            { stage: "销售关联报价", count: funnel.xiaoshou_linked_to_baojia },
            { stage: "销售关联询价", count: funnel.xiaoshou_linked_to_xunjia },
            { stage: "销售同时关联", count: funnel.xiaoshou_linked_to_both },
            { stage: "销售无来源关联", count: funnel.xiaoshou_without_source_links },
        ], [{ key: "stage", label: "关联状态" }, { key: "count", label: "单据数", format: formatCount }]);
    }

    function renderAlerts(alerts) {
        if (!alerts || !alerts.length) {
            return '<div class="analysis-report-empty is-clear">当前范围未发现需处理的管理预警</div>';
        }
        return '<ul class="analysis-report-alerts">' + alerts.map(function (alert) {
            return "<li><span>" + escapeHtml(alert.label) + "</span><strong>" + formatCount(alert.count) + "</strong></li>";
        }).join("") + "</ul>";
    }

    function renderAnalysisCharts(rootRef, data) {
        var Chart = rootRef["frappe-charts"] && rootRef["frappe-charts"].Chart;
        if (!Chart) {
            return;
        }
        var trend = data.monthly_trend || [];
        var funnel = data.funnel || {};
        var trendTarget = rootRef.document.getElementById("analysis-report-trend-chart");
        var funnelTarget = rootRef.document.getElementById("analysis-report-funnel-chart");
        if (trendTarget && trend.length) {
            rootRef.__analysisReportCharts.push(new Chart(trendTarget, {
                type: "line",
                height: 280,
                data: { labels: trend.map(function (row) { return row.month; }), datasets: [
                    { name: "询价", values: trend.map(function (row) { return row.xunjia_count; }) },
                    { name: "报价", values: trend.map(function (row) { return row.baojia_count; }) },
                    { name: "销售", values: trend.map(function (row) { return row.xiaoshou_count; }) },
                ] },
            }));
        }
        if (funnelTarget) {
            rootRef.__analysisReportCharts.push(new Chart(funnelTarget, {
                type: "bar",
                height: 280,
                data: { labels: ["询价", "报价", "销售"], datasets: [{ name: "单据数", values: [
                    Number(funnel.xunjia_count || 0), Number(funnel.baojia_count || 0), Number(funnel.xiaoshou_count || 0),
                ] }] },
            }));
        }
    }

    function showAnalysisState(reportRoot, type, message, canRetry) {
        reportRoot.innerHTML = '<section class="analysis-report-access-state ' + type + '">' + escapeHtml(message) +
            (canRetry ? '<button type="button" data-analysis-retry="1" aria-label="重新加载分析报告">重试</button>' : "") + "</section>";
    }

    function loadAnalysisReport(windowRef, reportRoot, rangeKey) {
        var selectedRange = normalizeAnalysisRange(rangeKey);
        var frappeApi = windowRef.frappe;
        reportRoot.dataset.selectedRange = selectedRange;
        if (!frappeApi || typeof frappeApi.call !== "function") {
            showAnalysisState(reportRoot, "is-error", "分析报告暂时无法加载", true);
            return;
        }
        showAnalysisState(reportRoot, "is-loading", "正在加载分析报告...");
        var requestOptions = getAnalysisRequestOptions(selectedRange);
        frappeApi.call({
            method: requestOptions.method,
            type: requestOptions.type,
            args: requestOptions.args,
            callback: function (response) {
                if (!response || !response.message) {
                    showAnalysisState(reportRoot, "is-empty", "当前范围暂无可展示数据");
                    return;
                }
                renderAnalysisDashboard(windowRef, response.message, selectedRange);
            },
            error: function (response) {
                var state = getAnalysisErrorState(response);
                showAnalysisState(
                    reportRoot,
                    state === "forbidden" ? "is-forbidden" : "is-error",
                    state === "forbidden" ? "您无权查看分析报告" : "分析报告加载失败，请重试",
                    state !== "forbidden"
                );
            },
        });
    }

    function initAnalysisReport(rootRef) {
        if (!rootRef || !isAnalysisReportPage(rootRef.document)) {
            return;
        }
        var reportRoot = rootRef.document.getElementById("analysis-report-dashboard");
        if (reportRoot.dataset.accessDenied === "1") {
            return;
        }
        reportRoot.addEventListener("click", function (event) {
            var button = event.target.closest("[data-analysis-range]");
            if (button) {
                loadAnalysisReport(rootRef, reportRoot, button.getAttribute("data-analysis-range"));
                return;
            }
            if (event.target.closest("[data-analysis-retry]")) {
                loadAnalysisReport(rootRef, reportRoot, reportRoot.dataset.selectedRange);
            }
        });
        loadAnalysisReport(rootRef, reportRoot, reportRoot.dataset.defaultRange);
    }

    if (root) {
        normalizeFrappeRequestUrl({
            request: root.frappe && root.frappe.request,
            location: root.location,
        });

        // 立即重定向1.autohaina.com的根路径访问
        // 使用replace()方法防止用户通过后退按钮返回原页面
        if (root.location.hostname === "1.autohaina.com" && root.location.pathname === "/") {
            root.location.replace("https://www.autohaina.com/");
        }

        initAnalysisReport(root);
    }

    if (typeof module === "object" && module.exports) {
        module.exports = {
            normalizeFrappeRequestUrl: normalizeFrappeRequestUrl,
            isAnalysisReportPage: isAnalysisReportPage,
            normalizeAnalysisRange: normalizeAnalysisRange,
            formatCny: formatCny,
            getAnalysisErrorState: getAnalysisErrorState,
            getAnalysisRequestOptions: getAnalysisRequestOptions,
            destroyAnalysisCharts: destroyAnalysisCharts,
            renderCustomerPreferenceTables: renderCustomerPreferenceTables,
            renderAnalysisDashboard: renderAnalysisDashboard,
        };
    }
})(typeof window !== "undefined" ? window : null);
